export enum ECRMIds {
    INSTANT_MESSAGE_CHANNEL = 'instant-message-channel',
    FUNNELS = 'all-funnels',
    AUTOMATIONS = 'automations',
};

export const CRMPageFragments = [
    {
        id: ECRMIds.INSTANT_MESSAGE_CHANNEL,
        title: 'SETTINGS.CRM.INSTANT_MESSAGING.CHANNEL_SECTION_TITLE',
    },
    {
        id: ECRMIds.FUNNELS,
        title: 'CRM.ALL_FUNNELS.FUNNELS',
    },
    {
        id: ECRMIds.AUTOMATIONS,
        title: 'CRM.AUTOMATIONS.AUTOMATIONS',
    },
];